
import onReady from '../utils/onReady';
import { addEvent } from '../utils/events';
import { remove as removeClass, toggle as toggleClass } from '../utils/classList';
import { currentBreakpoint, breakpointIndex, default as onWindowResize } from '../utils/responsiveWindow';
import { enable as enableScrollLock, disable as disableScrollLock } from '../utils/scrollLock';

class MobileMenu {

    constructor(container) {
        if (window.NodeList && !NodeList.prototype.forEach) {
            NodeList.prototype.forEach = Array.prototype.forEach;
        }

        onReady(() => this.init(container));
    }

    cleanupMobileMenu() {
        if (currentBreakpoint >= breakpointIndex.md) {
            // Reset the states on button, body and mobile menu
            this.dom.trigger.setAttribute("aria-expanded", "false");
            this.dom.trigger.setAttribute("aria-hidden", "true");
            removeClass(document.querySelector("body"), "mobilesitenav--visible");
            this.dom.navigation.setAttribute("aria-expanded", "false");
            this.dom.navigation.setAttribute("aria-hidden", "true");
            disableScrollLock();
        } else {
            this.dom.trigger.setAttribute("aria-hidden", "false");
        }
    }

    toggleMobileMenu() {
        addEvent(this.dom.trigger, "click", () => {
            // Get state from trigger button and navigation
            const open = JSON.parse(this.dom.trigger.getAttribute("aria-expanded"));
            const hidden = JSON.parse(this.dom.navigation.getAttribute("aria-hidden"));
            // Set the states on button, body and mobile menu
            this.dom.trigger.setAttribute("aria-expanded", !open);
            toggleClass(document.querySelector("body"), "mobilesitenav--visible");
            this.dom.navigation.setAttribute("aria-expanded", !open);
            this.dom.navigation.setAttribute("aria-hidden", !hidden);

            if (open) {
                disableScrollLock();
            } else {
                enableScrollLock();
            }
        });
    }

    toggleSubLevelMenu() {
        this.dom.sublevelTriggers.forEach((button) => {
            const subLevelMenu = button.nextElementSibling;

            addEvent(subLevelMenu, "transitionend", e => {
                if (e.propertyName == "max-height") {
                    const hidden = JSON.parse(subLevelMenu.getAttribute("aria-hidden"));
                    if (hidden) {
                        subLevelMenu.style.display = "none";
                    } else {
                        subLevelMenu.style.display = "block";
                    }
                }
            });

            addEvent(button, "click", () => {
                // handle button state
                const open = JSON.parse(button.getAttribute("aria-expanded"));
                button.setAttribute("aria-expanded", !open);
                toggleClass(button, "icon--mirror");

                // handle sub level menu
                const hidden = JSON.parse(subLevelMenu.getAttribute("aria-hidden"));
                subLevelMenu.setAttribute("aria-expanded", !open);
                subLevelMenu.setAttribute("aria-hidden", !hidden);

                if (hidden) {
                    subLevelMenu.style.display = "block";
                    setTimeout(() => {
                        subLevelMenu.style.maxHeight = "5000px";
                    }, 50);
                } else {
                    subLevelMenu.style.maxHeight = "0px";
                }
            });
        });
    }

    init(container) {

        this.dom = {
            container,
            trigger: document.getElementById("mobilemenu__trigger"),
            navigation: container.querySelector(".sitenav__nav"),
            sublevelTriggers: container.querySelectorAll(".sublevel-trigger")
        };

        // Open/close mobile menu
        this.toggleMobileMenu();

        // Open/close sublevel menus
        this.toggleSubLevelMenu();

        onWindowResize(this.cleanupMobileMenu.bind(this));

        if (currentBreakpoint < breakpointIndex.md) {
            this.dom.trigger.setAttribute("aria-hidden", "false");
        }
    }
}

export default MobileMenu;